import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, getOwnerFilter, setOwnerFilter } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Filter } from "lucide-react";

export function OwnerFilter() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [value, setValue] = useState(getOwnerFilter() || "all");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user?.role === "admin") api.get("/users").then((r) => setUsers(r.data)).catch(() => {});
  }, [user]);

  if (user?.role !== "admin") return null;

  const change = (v) => {
    setValue(v);
    setOwnerFilter(v === "all" ? "" : v);
    navigate(location.pathname, { replace: true });
    window.location.reload();
  };

  return (
    <div className="flex items-center gap-2" data-testid="owner-filter">
      <Filter className="hidden h-4 w-4 text-muted-foreground sm:block" />
      <Select value={value} onValueChange={change}>
        <SelectTrigger className="h-9 w-36 sm:w-56" data-testid="owner-filter-select"><SelectValue placeholder="Kullanıcı seç" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tüm kullanıcılar</SelectItem>
          {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name || u.email}{u.id === user.id ? " (siz)" : ""}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
